<script lang="ts" setup>
import { routerBack } from "@/use/go";
import { useExplore } from "@/stores/explore";
import { computed, onActivated, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Search } from "vant";
import { onClickOutside, onKeyStroke } from "@vueuse/core";
import QuickSearchResultList from "@/components/mobile/search/QuickSearchResultList.vue";
import { isMobile } from "@/modules/common";

// Props
const props = defineProps<{
  maxHotTagCount?: number;
}>();

const emit = defineEmits<{
  (e: "onSearch"): void;
}>();
// States
const searchRouteName = ["search", "nsfwChatMateTag"];
const explore = useExplore();
const route = useRoute();
const router = useRouter();
const isSearchRoute = computed(() =>
  searchRouteName.includes(route.name as string)
);
const searchRef = ref<HTMLTextAreaElement | null>(null);
const searchContainer = ref<HTMLElement | null>(null);
const showSearchPopover = ref(false);
onClickOutside(searchContainer, () => (showSearchPopover.value = false));

// Lifecycle
const recoverSearchText = () => {
  if (isSearchRoute.value) {
    explore.searchText = route.query.q as string;
  } else {
    explore.searchText = "";
  }
};
onMounted(() => {
  recoverSearchText();
});

onActivated(() => {
  recoverSearchText();
});

onKeyStroke("/", (e) => {
  if (searchRef.value && !showSearchPopover.value) {
    e.preventDefault();
    searchRef.value.focus();
  }
});

watch(
  () => route.query,
  () => {
    recoverSearchText();
  }
);

// Event Handler
const handleSearch = (text?: string) => {
  if (text) {
    explore.searchText = text;
  }
  if (isSearchRoute.value) {
    router.replace({
      query: {
        ...route.query,
        q: explore.searchText,
      },
    });
  } else {
    router.push({
      name: "search",
      query: {
        q: explore.searchText,
      },
    });
  }
  emit("onSearch");
};
</script>
<template>
  <div ref="searchContainer" class="relative bg-base-100 flex">
    <div class="flex gap-1 lg:items-stretch items-center flex-1">
      <button
        v-if="isSearchRoute"
        class="btn btn-ghost btn-circle btn-sm lg:btn-md h-full"
        @click.stop="routerBack()"
      >
        <light-arrow-icon />
      </button>
      <!-- <div
        class="w-full flex items-center rounded overflow-hidden h-full bg-base-300 border focus:border-2 py-1 pr-2"
      >
        <input
          ref="searchRef"
          v-model="explore.searchText"
          type="text"
          :placeholder="$t('Message.searchPlaceholder')"
          autocomplete="off"
          class="input input-bordered h-full bg-transparent border-0 text-sm flex-1 rounded-none focus:outline-none"
          @keyup.enter="handleSearch()"
          @keyup.esc="
            showSearchPopover = false;
            searchRef?.blur();
          "
          @focus="showSearchPopover = true"
        />
        <button class="btn btn-xs xs:btn-sm rounded" @click="handleSearch()">
          {{ $t("Message.search") }}
        </button>
        <kbd
          v-show="!showSearchPopover"
          class="kbd hidden lg:flex absolute right-16 top-1/2 -translate-y-1/2"
        >
          /
        </kbd>
      </div> -->
    </div>
    <QuickSearchResultList
      v-if="false"
      v-show="showSearchPopover && !isSearchRoute && !isMobile()"
      :max-hot-tag-count="maxHotTagCount"
      class="absolute py-4 bg-base-200 border border-base-content/20 left-0 right-0 top-[3rem] z-20 mx-4 rounded-xl shadow-lg"
      @onTagSelect="
        showSearchPopover = false;
        handleSearch($event);
      "
    />
  </div>
</template>
